/**
 * 当前用户对某一文档/文件夹的权限.
 * - [后台协议](https://git.woa.com/docx-online/docx-online/blob/889d7d94/backend/common/proto/3rd/oidb/cmd0xafd/oidb_0xafd.proto#L401)
 *
 * 使用时应该尽可能使用具体权限的 canXXX 字段, 这样才能尽量对齐后台的权限计算逻辑.
 * 尽量不要通过角色字段 isAuth, isAdmin 来做权限判断.
 *
 * 其中每一个字段的取值遵循以下规则:
 * - `true`: 表示有权限, 当前用户可以执行该操作.
 * - `false`: 表示无权限, 当前用户不可以执行该操作.
 * - `null`: 表示未知, 通常是后台未返回, 此时当作是无权限处理.
 *
 * TODO: @mingqiuliao 这里的定义和 `packages/desktop-kit/src/file/models/types-attribute.ts` 中有重复，需想办法复用
 */

/**
 * 如果有新增权限协议的字段，应该更新 `@tencent/tdocs-shared-types` 这个包，而不是在这里自行扩展字段
 * 开发联调阶段可以临时这样做。最终希望跟后台协议对齐。发包有疑问可联系 @mingqiuliao
 */

/** Owner 权限, 除了 SaaS 需求的退出文档权限以外，所有的操作均为 true */
export var OWNER_PERMISSIONS = {
  canAbout: true,
  canAddUser: true,
  canAnnotate: true,
  canApplyEdit: true,
  canAddRevision: true,
  canComment: true,
  canCopy: true,
  canCopyDoc: true,
  canCreateFile: true,
  canCreateFolder: true,
  canDelete: true,
  canDeleteAbsolutely: true,
  canEdit: true,
  canEditCollab: true,
  canEditForm: true,
  canEditPrivSetting: true,
  canEditTab: true,
  canEditTitle: true,
  canExit: false,
  canExport: true,
  canFill: true,
  canFilterUser: true,
  canForbidViewerComment: true,
  canForbidViewerCopyDoc: true,
  canHistory: true,
  canInviteMember: true,
  canInviteSpecialDepts: true,
  canLinkExp: true,
  canMove: true,
  canPrint: true,
  canPublish: true,
  canRead: true,
  canRestore: true,
  canSaveTemplate: true,
  canSearch: true,
  canSearchUser: true,
  canSetEnterRule: true,
  canSetExternalAccess: true,
  canSetInternalAccess: true,
  canSetRange: true,
  canSetRangePrivilege: true,
  canSetSecuritySetting: true,
  canShare: true,
  canSpitSlot: true,
  canTransfer: true,
  canTranslate: true,
  canViewBrowsingHistory: true,
  canViewCollab: true,
  canViewImage: true,
  canViewPrivSetting: true,
  canWatermark: true,
  isAdmin: true,
  isAuth: true,
  canCopyOut: true,
  canRestoreInherit: true,
  canCollect: true,
  canHighLightTitle: true,
  canPersonalityLike: true,
  canInvisibleVisit: true,
  canViewRangePrivilege: true,
  canNotice: true,
  canAssociateDoc: true,
  canMultiEdit: true
};

/**
 * 用户权限角色. 表示用户在某个文件或文件夹中的权限角色.
 *
 * 注意: 权限角色的数值虽然看起来有一定的顺序, 但实际上没有, 不可使用 >= 等运算符进行数值比较. (percychen)
 */
export var UserRole = /*#__PURE__*/function (UserRole) {
  UserRole[UserRole["Unauthorized"] = 0] = "Unauthorized";
  UserRole[UserRole["Readable"] = 1] = "Readable";
  UserRole[UserRole["Editable"] = 2] = "Editable";
  UserRole[UserRole["Fillable"] = 3] = "Fillable";
  UserRole[UserRole["AllowExecute"] = 4] = "AllowExecute";
  UserRole[UserRole["AllowExtern"] = 10] = "AllowExtern";
  UserRole[UserRole["Inherit"] = 20] = "Inherit";
  UserRole[UserRole["Admin"] = 1024] = "Admin";
  UserRole[UserRole["Owner"] = 2048] = "Owner";
  return UserRole;
}({});
//# sourceMappingURL=permission.js.map